<template lang="pug">
v-card.mb-3(v-if="hasEmail")
  v-card-title.grey.lighten-4
    .title {{extra.name}}
  v-card-text.pt-0
  template(v-for="ticket in nichtErledigt")
    .px-3.py-1.d-flexx(@click="startEdit(ticket)")
      v-icon(:color="ticketColor(ticket)") {{ticketIcon(ticket)}}
      |  &nbsp;
      span.text-truncate {{ticket.id}}: {{ticket.betreff}}

  v-btn(@click="showErledigt = !showErledigt" flat v-if="erledigt.length")
    | Alle Anzeigen
    v-icon {{showErledigt ? 'arrow_drop_down' : 'arrow_drop_up'}}

  template(v-if="showErledigt" v-for="ticket in erledigt")
    .px-3.py-1.d-flexx(@click="startEdit(ticket)")
      v-icon(:color="ticketColor(ticket)") {{ticketIcon(ticket)}}
      span.text-truncate {{ticket.id}}: {{ticket.betreff}}

  v-dialog(:value="!!edit" @input="edit = null" lazy max-width="700")
    v-card(v-if="edit")
      v-card-title.pb-0
        | {{edit.id}}: {{edit.betreff}}
        v-spacer
        v-btn(@click="edit = null" icon): v-icon close
      v-card-text.pt-0
        radio-group(label="Status" :value="edit.status" @change="updateStatus" row :items="statusOptions")
        v-text-field(label="Erstellt" :value="showDate(edit.createdAt)" disabled)
        .text-wrap-lines.mt-3 {{edit.textStripped}}

</template>

<script>
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'
import { user } from '../../router'
import moment from 'moment'

export default {
  mixins: [GraphqlErrorObject],
  props: ['extra'],
  data() {
    return {
      user,
      edit: null,
      showErledigt: false,
      itTickets: [],
      statusOptions: [
        { text: 'Neu', value: 'neu' },
        { text: 'In Bearbeitung', value: 'in_bearbeitung' },
        { text: 'Erledigt', value: 'erledigt' },
        { text: 'Geschlossen', value: 'geschlossen' }
      ]
    }
  },
  apollo: {
    itTickets: {
      query: gql`query ($email: String) {
        itTickets(order: "updated_at:desc" where: { email: $email }) {
          id
          status
          betreff
          textStripped
          createdAt
        }
      }`,
      variables() {
        return {
          email: this.user && this.user.email
        }
      },
      skip() {
        return !this.hasEmail
      }
    }
  },
  computed: {
    hasEmail() {
      return !!(this.user && this.user.email)
    },
    erledigt() {
      return this.itTickets.filter(ticket => ticket.status === 'erledigt' || ticket.status === 'geschlossen')
    },
    nichtErledigt() {
      return this.itTickets.filter(ticket => !(ticket.status === 'erledigt' || ticket.status === 'geschlossen'))
    }
  },
  methods: {
    showDate(date) {
      return moment(date).format("DD.MM.Y")
    },
    startEdit(ticket) {
      this.edit = { ...ticket }
    },
    ticketIcon(ticket) {
      switch (ticket.status) {
        case 'in_bearbeitung':
          return 'indeterminate_check_box'
        case 'erledigt':
        case 'geschlossen':
          return 'check_box'
        default:
          return 'check_box_outline_blank'
      }
    },
    ticketColor(ticket) {
      switch (ticket.status) {
        case 'in_bearbeitung':
          return 'orange'
        case 'erledigt':
          return 'green'
        case 'geschlossen':
        default:
          return 'red'
      }
    },
    updateStatus(status) {
      const statusObj = this.statusOptions.find(s => s.value === status)
      if (confirm(`${this.edit.id}: ${this.edit.betreff} status ändern zu: ${statusObj ? statusObj.text : status}?`)) {
        this.gqlClearAllErrors()
        this.$apollo.mutate({
          mutation: gql`mutation ($id: ID!, $status: String) {
            itTicketUpdate(id: $id, status: $status) {
              id
              status
            }
          }`,
          variables: {
            id: this.edit.id,
            status
          },
        }).then((response) => {
            if (response.data.itTicketUpdate.status === status) {
              this.edit = null
            } else {
              this.resetStatus()
            }
        }).catch((error) => {
          this.gqlAddErrors(error)
          this.resetStatus()
        })
      } else {
        this.resetStatus()
      }
    },
    resetStatus() {
      const statusOld = this.edit.status
      this.edit.status = null
      this.$nextTick(() => {
        this.edit.status = statusOld
      })
    }
  }
}
</script>
